"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const paths_1 = require("@/common/app/paths");
const utils_1 = require("@/common/utils/utils");
const SoundManager_1 = require("@/client/utils/SoundManager");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const LogMessageComponent_vue_1 = require("@/client/components/logpanel/LogMessageComponent.vue");
const CardPanel_vue_1 = require("@/client/components/logpanel/CardPanel.vue");
const spaces_1 = require("@/common/boards/spaces");
let logAbortController;
exports.default = vue_1.default.extend({
    name: 'log-panel',
    props: {
        viewModel: {
            type: Object,
        },
        color: {
            type: String,
        },
        step: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            messages: [],
            selectedGeneration: -1,
            selectedMessage: undefined,
        };
    },
    components: {
        LogMessageComponent: LogMessageComponent_vue_1.default,
        CardPanel: CardPanel_vue_1.default,
    },
    methods: {
        messageClicked(message) {
            this.selectedMessage = message;
        },
        spaceClicked(spaceId) {
            const id = (0, spaces_1.isMarsSpace)(spaceId) ? 'shortkey-board' : 'shortkey-moonBoard';
            const el = document.getElementById(id);
            el?.scrollIntoView({ block: 'center', inline: 'center', behavior: 'auto' });
            const regions = ['main_board', 'moon_board', 'moon_board_outer_spaces'];
            for (const region of regions) {
                const board = document.getElementById(region);
                if (board !== null) {
                    const array = board.getElementsByClassName('board-log-highlight');
                    for (let i = 0, length = array.length; i < length; i++) {
                        const element = array[i];
                        if (element.getAttribute('data_log_highlight_id') === spaceId) {
                            element.classList.add('highlight');
                            setTimeout(() => {
                                element.classList.remove('highlight');
                            }, 3000);
                            return;
                        }
                    }
                }
            }
        },
        selectGeneration(gen) {
            if (gen !== this.selectedGeneration) {
                this.getLogsForGeneration(gen);
            }
            this.selectedGeneration = gen;
        },
        getLogsForGeneration(generation) {
            const messages = this.messages;
            if (logAbortController) {
                logAbortController.abort();
                logAbortController = undefined;
            }
            const url = `${paths_1.paths.API_GAME_LOGS}?id=${this.id}&generation=${generation}`;
            const controller = new AbortController();
            logAbortController = controller;
            fetch(url, { signal: controller.signal })
                .then((resp) => {
                if (!resp.ok) {
                    console.error(`error updating messages, response code ${resp.status}`);
                    return null;
                }
                return resp.json();
            })
                .then((data) => {
                if (!data)
                    return;
                messages.splice(0, messages.length);
                messages.push(...data);
                if ((0, PreferencesManager_1.getPreferences)().enable_sounds && window.location.search.includes('experimental=1')) {
                    SoundManager_1.SoundManager.newLog();
                }
                if (generation === this.generation) {
                    this.$nextTick(this.scrollToEnd);
                }
            })
                .catch((err) => {
                if (err.name === 'AbortError')
                    return;
                console.error('error updating messages, unable to reach server');
            });
        },
        scrollToEnd() {
            const scrollablePanel = document.getElementById('logpanel-scrollable');
            if (scrollablePanel !== null) {
                scrollablePanel.scrollTop = scrollablePanel.scrollHeight;
            }
        },
        getClassesGenIndicator(gen) {
            const classes = ['log-gen-indicator'];
            if (gen === this.selectedGeneration) {
                classes.push('log-gen-indicator--selected');
            }
            return classes.join(' ');
        },
        getGenerationsRange() {
            const generations = [];
            for (let i = 1; i <= this.generation; i++) {
                generations.push(i);
            }
            return generations;
        },
        getTitleClasses() {
            const classes = ['log-title'];
            classes.push((0, utils_1.playerColorClass)(this.color, 'shadow'));
            return classes.join(' ');
        },
        lastGenerationClass() {
            return this.lastSoloGeneration === this.generation ? 'last-generation blink-animation' : '';
        },
    },
    computed: {
        generation() {
            return this.viewModel.game.generation;
        },
        lastSoloGeneration() {
            return this.viewModel.game.lastSoloGeneration;
        },
        players() {
            return this.viewModel.players;
        },
        id() {
            return this.viewModel.id;
        },
    },
    mounted() {
        this.selectedGeneration = this.generation;
        this.getLogsForGeneration(this.generation);
    },
});
